import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Team API functions
export const createTeam = async (teamData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.TEAM.CREATE, teamData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to create team');
  }
};

export const getAllTeams = async (queryParams = {}) => {
  const params = {
    page: queryParams?.page || 1,
    search: queryParams?.search || '',
    sortBy: queryParams?.sortBy || 'createdAt',
    role: queryParams?.role || ""
  };
  try {
    const response = await axiosInstance.get(API_ROUTES.TEAM.GET_ALL, { params});
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch teams');
  }
};

export const getTeamById = async (teamId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.TEAM.GET_SINGLE}/${teamId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch team');
  }
};

export const updateTeam = async (teamId, teamData) => {
  try {
    const response = await axiosInstance.put(`${API_ROUTES.TEAM.UPDATE}/${teamId}`, teamData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to update team');
  }
};

export const deleteTeam = async (teamId) => {
  try {
    const response = await axiosInstance.delete(`${API_ROUTES.TEAM.DELETE}`, {
      data: {
        ids: teamId // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to delete team');
  }
};

// Role API functions
export const createRole = async (roleData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.ROLE.CREATE, roleData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to create role');
  }
};

export const getAllRoles = async () => {
  try {
    const response = await axiosInstance.get(API_ROUTES.ROLE.GET_ALL);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch roles');
  }
};

export const getRoleById = async (roleId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.ROLE.GET_SINGLE}/${roleId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch role');
  }
};

export const updateRole = async (roleId, roleData) => {
  try {
    const response = await axiosInstance.put(`${API_ROUTES.ROLE.UPDATE}/${roleId}`, roleData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to update role');
  }
};

export const deleteRole = async (roleId) => {
  try {
    const response = await axiosInstance.delete(`${API_ROUTES.ROLE.DELETE}`, {
      data: {
        ids: roleId // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to delete role');
  }
};